import {
  PropHeroText,
  TEXT_COLOR,
  TEXT_TYPOGRAPHY,
  TEXT_WEIGHT,
} from "@prophero-ds/react-components";

type PasswordHeaderProps = {
  title: string;
  description: string;
};

function PasswordHeader({ title, description }: PasswordHeaderProps) {
  return (
    <div className="flex flex-col gap-1">
      <PropHeroText
        typography={TEXT_TYPOGRAPHY["Header-lg"]}
        weight={TEXT_WEIGHT.medium}
        color={TEXT_COLOR.primary}
      >
        {title}
      </PropHeroText>
      <PropHeroText
        typography={TEXT_TYPOGRAPHY["Text-md"]}
        weight={TEXT_WEIGHT.regular}
        color={TEXT_COLOR.secondary}
      >
        {description}
      </PropHeroText>
    </div>
  );
}

export default PasswordHeader;
